import { render, staticRenderFns } from "./Strat.vue?vue&type=template&id=4a686608&scoped=true&"
import script from "./Strat.vue?vue&type=script&lang=ts&"
export * from "./Strat.vue?vue&type=script&lang=ts&"
import style0 from "./Strat.vue?vue&type=style&index=0&id=4a686608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a686608",
  null
  
)

export default component.exports